// import { Nav } from 'react-bootstrap';
import NavigationData from './NavigationData';

/** MOCK itens menu lateral */
// export const sideNavItems = [
//     <Nav.Link href='#'>Item 1</Nav.Link>,
// ]

/** Service para dados de navigation */
const NavigationService = {
    /** Retorna os dados para menu de navegação */
    getNavigationData: (resource_access) => {
        return NavigationData.navigation
            .filter(item => {
                if (item.allowedRoles) {
                    return item.allowedRoles.some(role => resource_access.includes(role));
                }
                return resource_access.includes(item.key);
            })
            .sort((a, b) => a.order - b.order);
    },

    /** Retorna os items de subgrupo de navegação, filtrando por allowedRoles quando definido */
    getSubNavData: (navKey, resource_access) => {
        const subgroup = NavigationData.subgroups[navKey];
        if (!subgroup) return [];

        return subgroup.filter(item => {
            if (item.allowedRoles) {
                return item.allowedRoles.some(role => resource_access.includes(role));
            }
            return true;
        });
    }
}

export default NavigationService;
